export const ACTIVITIES_LOG_QUERY = "activitiesLog";
export const ACTIVITY_LOG_PAGE_SIZE = 50;
